import { connect } from 'react-redux';
import { compose } from 'redux';
import { actions } from 'reducers';

import PropTypes from 'prop-types';
import reduce from 'lodash/reduce';

const putHttpProps = (Component, requests) => {
	Component.propTypes = {
		classes: PropTypes.object,
		dispatch: PropTypes.func.isRequired
	};

	Component.contextTypes = {
		store: PropTypes.object
	};

	const mapStateToProps = state => {
		return {
			...reduce(
				requests,
				(accumulator, element) => {
					accumulator[ `${element}` ] = state[ `${element}` ];
					accumulator[ `${element}Loading` ] = state[ `${element}Loading` ];
					accumulator[ `${element}Error` ] = state[ `${element}Error` ];
					return accumulator;
				},
				{}
			)
		};
	};

	function mapDispatchToProps(dispatch) {
		return {
			dispatch,
			httpCall: (id, params, callbacks) => {
				if (dispatch) {
					dispatch(actions[ id ](params, callbacks));
				} else {
					if (callbacks && callbacks.catch) {
						callbacks.catch('error during request call');
					}
				}
			}
		};
	}

	const withConnect = connect(
		mapStateToProps,
		mapDispatchToProps
	);

	const ComponentExport = compose(withConnect)(Component);

	return ComponentExport;
};

export default putHttpProps;



// WEBPACK FOOTER //
// ./src/libraries/reducers/http-request/wrapper.js